import { ABaseModel } from '../abstracts/ABaseModel.js';
import { ILegal, ILegalLocale, IAcceptedLegal, IAcceptedLegalListResult } from '../interfaces/Legal.js';
import { ListResult } from './List.js';

/**
 * Legal
 */
class Legal extends ABaseModel implements ILegal {
  id: number;
  type: string;
  active: boolean;
  version: string;
  effectiveDate: string;
  title: string;
  legalText: string;
  locales: Array<LegalLocale>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * LegalLocale
 */
class LegalLocale extends ABaseModel implements ILegalLocale {
  id: number;
  localeCode: string;
  title: string;
  legalText: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * AcceptedLegal
 */
class AcceptedLegal extends Legal implements IAcceptedLegal {
  acceptedDate: string;
  legalId: number;
  userId: number;
  userRole: string;
  userFullName: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AcceptedLegalListResult
 */
class AcceptedLegalListResult extends ListResult implements IAcceptedLegalListResult {
  declare items: Array<AcceptedLegal>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Legal, LegalLocale, AcceptedLegal, AcceptedLegalListResult };
